import script from "./SupplementalDocumentsUploadComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplementalDocumentsUploadComponent.vue?vue&type=script&setup=true&lang=js"

import "./SupplementalDocumentsUploadComponent.vue?vue&type=style&index=0&id=767ada0c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-767ada0c"]])

export default __exports__